import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    api.verifyEmail(token)
      .then((data) => {
        setStatus('success');
        setMessage(data.message || 'Email verified! You can now sign in.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'Verification failed.');
      });
  }, [token]);

  return (
    <main className="auth-page container">
      <div className="auth-card card" style={{ textAlign: 'center', padding: '40px 24px' }}>
        {status === 'loading' && <p>Verifying your email...</p>}

        {status === 'success' && (
          <>
            <h2 style={{ color: 'var(--success, #38a169)', marginBottom: 12 }}>Verified!</h2>
            <p style={{ color: 'var(--gray-500)', marginBottom: 20 }}>{message}</p>
            <Link to="/auth" className="btn btn-primary">Sign In</Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 style={{ color: 'var(--danger, #e53e3e)', marginBottom: 12 }}>Verification Failed</h2>
            <p style={{ color: 'var(--gray-500)', marginBottom: 20 }}>{message}</p>
            <Link to="/auth" className="btn btn-primary">Back to Sign In</Link>
          </>
        )}
      </div>
    </main>
  );
}
